/**
 * Header controller: desktop mega menu (hover-intent + click fallback for
 * touch/tablet), mobile drill-down drawer with inline accordions at level 0,
 * search panel toggle, and a light sticky-scroll shadow. All state classes
 * use the MB- prefix to stay clear of the theme's own class names.
 */
(function () {
  var MEGA_CLOSE_DELAY = 150;

  function initMegaMenus(header) {
    var items = header.querySelectorAll('.MB-site-header__nav-item--has-mega');

    items.forEach(function (item) {
      var closeTimer = null;
      var megaMenu = item.querySelector('.MB-mega-menu');
      if (!megaMenu) return;

      function open() {
        clearTimeout(closeTimer);
        item.classList.add('MB-is-open');
      }
      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          item.classList.remove('MB-is-open');
        }, MEGA_CLOSE_DELAY);
      }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', scheduleClose);

      // Touch/tablet fallback: tap the parent link toggles the mega menu
      // instead of navigating, since hover doesn't apply there.
      var trigger = item.querySelector('.MB-site-header__nav-link');
      trigger.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: hover)').matches) return;
        e.preventDefault();
        var isOpen = item.classList.contains('MB-is-open');
        items.forEach(function (i) { i.classList.remove('MB-is-open'); });
        if (!isOpen) item.classList.add('MB-is-open');
      });

      // Sidebar category hover/click swaps the active product panel.
      var categories = megaMenu.querySelectorAll('[data-mega-category]');
      categories.forEach(function (cat) {
        cat.addEventListener('mouseenter', function () { activateCategory(megaMenu, cat); });
        cat.addEventListener('focus', function () { activateCategory(megaMenu, cat); });
      });
    });

    document.addEventListener('click', function (e) {
      items.forEach(function (item) {
        if (!item.contains(e.target)) item.classList.remove('MB-is-open');
      });
    });
  }

  function activateCategory(megaMenu, cat) {
    var targetId = cat.getAttribute('data-mega-target');
    megaMenu.querySelectorAll('[data-mega-category]').forEach(function (c) {
      c.classList.toggle('MB-is-active', c === cat);
    });
    megaMenu.querySelectorAll('[data-mega-panel]').forEach(function (panel) {
      panel.classList.toggle('MB-is-active', panel.id === targetId);
    });
  }

  function initMobileMenu(root) {
    var openBtn = document.querySelector('[data-mobile-menu-open]');
    var closeEls = root.querySelectorAll('[data-mobile-menu-close]');
    var levels = root.querySelectorAll('[data-mobile-level]');
    var history = ['0'];

    function showLevel(name) {
      levels.forEach(function (level) {
        level.classList.toggle('MB-is-active', level.getAttribute('data-mobile-level') === name);
      });
    }

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        root.hidden = false;
        requestAnimationFrame(function () { root.classList.add('MB-is-open'); });
        history = ['0'];
        showLevel('0');
      });
    }

    closeEls.forEach(function (el) {
      el.addEventListener('click', function () {
        root.classList.remove('MB-is-open');
        setTimeout(function () { root.hidden = true; }, 300);
      });
    });

    // Level 0 accordions: tapping a top-level item expands its category list
    // inline, in place, without hiding the rest of the level-0 list. Only
    // one accordion is open at a time; tapping an open one closes it.
    root.querySelectorAll('[data-mobile-accordion-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        // Close any other open accordion first.
        root.querySelectorAll('[data-mobile-accordion-toggle]').forEach(function (otherBtn) {
          if (otherBtn === btn) return;
          var otherPanel = document.getElementById(otherBtn.getAttribute('aria-controls'));
          otherBtn.setAttribute('aria-expanded', 'false');
          otherBtn.classList.remove('MB-is-open');
          if (otherPanel) otherPanel.hidden = true;
        });

        btn.setAttribute('aria-expanded', String(!isOpen));
        btn.classList.toggle('MB-is-open', !isOpen);
        panel.hidden = isOpen;
      });
    });

    // Drilling into a category (from inside an expanded accordion) still
    // slides in a brand new full-screen panel with the product grid.
    root.querySelectorAll('[data-mobile-drill-to]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-mobile-drill-to');
        history.push(target);
        showLevel(target);
      });
    });

    root.querySelectorAll('[data-mobile-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        history.pop();
        showLevel(history[history.length - 1]);
      });
    });
  }

 function initSearch(header) {
    if (header.dataset.searchInitialized === 'true') return;
    header.dataset.searchInitialized = 'true';

    var panel = header.querySelector('[data-search-panel]');
    var close = header.querySelector('[data-search-close]');
    if (!panel) return;

    function toggleSearch() {
      panel.hidden = !panel.hidden;
      if (!panel.hidden) {
        var input = panel.querySelector('input[name="q"]');
        if (input) input.focus();
      }
    }

    var mobileToggle = header.querySelector('[data-search-toggle]');
    if (mobileToggle) mobileToggle.addEventListener('click', toggleSearch);

    var desktopToggle = header.querySelector('[data-search-toggle-desktop]');
    if (desktopToggle) desktopToggle.addEventListener('click', toggleSearch);

    if (close) {
      close.addEventListener('click', function () { panel.hidden = true; });
    }
  }

  function initTopbar(bar) {
    var track = bar.querySelector('[data-topbar-track]');
    var slides = bar.querySelectorAll('.MB-site-header__topbar-slide');
    if (!track || slides.length <= 1) return;

    var index = 0;
    var autoplay = bar.getAttribute('data-topbar-autoplay') === 'true';
    var speed = parseInt(bar.getAttribute('data-topbar-speed'), 10) || 5;
    var timer = null;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }
    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, speed * 1000);
    }

    var nextBtn = bar.querySelector('[data-topbar-next]');
    var prevBtn = bar.querySelector('[data-topbar-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });

    // Pause while hovered/focused so people can actually read + click a link.
    bar.addEventListener('mouseenter', stopAutoplay);
    bar.addEventListener('mouseleave', startAutoplay);
    bar.addEventListener('focusin', stopAutoplay);
    bar.addEventListener('focusout', startAutoplay);

    goTo(0);
    startAutoplay();
  }

  function initSticky(header) {
    if (header.getAttribute('data-sticky') !== 'true') return;

    // Driven entirely by JS (position: fixed) rather than CSS position:
    // sticky, because sticky silently stops working if any ancestor in the
    // theme's layout has overflow:hidden/auto or a transform on it — a very
    // common Shopify pattern (section wrappers, page-transition libraries,
    // etc.) with no console error to point at. Fixed positioning avoids
    // that dependency entirely.
    var spacer = document.createElement('div');
    spacer.className = 'MB-site-header-spacer';
    header.parentNode.insertBefore(spacer, header.nextSibling);

    var pinned = false;

    function pin() {
      if (pinned) return;
      spacer.style.height = header.offsetHeight + 'px';
      spacer.classList.add('MB-is-active');
      header.classList.add('MB-site-header--pinned');
      pinned = true;
    }

    function unpin() {
      if (!pinned) return;
      header.classList.remove('MB-site-header--pinned');
      spacer.classList.remove('MB-is-active');
      spacer.style.height = '';
      pinned = false;
    }

    function onScroll() {
      if (window.scrollY > 0) {
        pin();
        header.classList.toggle('MB-is-scrolled', window.scrollY > 4);
      } else {
        unpin();
        header.classList.remove('MB-is-scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (pinned) spacer.style.height = header.offsetHeight + 'px';
    });

    onScroll();
  }

  function initCartCountSync(header) {
    // Themes/apps that update the cart via AJAX can dispatch this event
    // with { detail: { itemCount } } to keep the header badge in sync.
    document.addEventListener('cart:updated', function (e) {
      var countEl = header.querySelector('[data-cart-count]');
      if (!countEl || !e.detail || typeof e.detail.itemCount === 'undefined') return;
      countEl.textContent = e.detail.itemCount;
      countEl.hidden = e.detail.itemCount === 0;
    });
  }

  function updateMegaMenuOffset() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--mb-header-height', bottom + 'px');
  }

  function init() {
    var header = document.querySelector('[data-site-header]');
    var mobileMenu = document.querySelector('[data-mobile-menu]');
    var topbar = document.querySelector('[data-topbar]');
    if (topbar) initTopbar(topbar);
    if (header) {
      initMegaMenus(header);
      initSearch(header);
      initSticky(header);
      initCartCountSync(header);

      header.querySelectorAll('.MB-site-header__nav-item--has-mega').forEach(function (item) {
        item.addEventListener('mouseenter', updateMegaMenuOffset);
        item.addEventListener('focusin', updateMegaMenuOffset);
      });
    }
    if (mobileMenu) initMobileMenu(mobileMenu);

    updateMegaMenuOffset();
  }

  window.addEventListener('resize', updateMegaMenuOffset);

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();